import React, {Component} from 'react';
import PersonObituary from './personObituary';
import './css/Obituary.styl';

class Obituary extends Component {
  render() {
    return (
      <div className="obit-group">
        {this.props.person.obituaries.map((personObit, i) => (
          <PersonObituary key={i} personObit={personObit} />
        ))}
      </div>
    );
  }
}

export default Obituary;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/Obituaries/obituary.js